import React from 'react'
import Markdown from 'markdown-to-jsx'
import { css, Global } from '@emotion/core'
import { Row } from '@fs/zion-ui'
import { createMarkdownStyles } from '../../../../assets/markdownStyles'

const markDownStyles = css`
  .markdown-body {
    all: initial;
    box-sizing: border-box;
    min-width: 200px;
    max-width: 980px;
    margin: 0 auto;
    padding: 45px;
  }
  ${createMarkdownStyles('markdown-body')}
`

export default function PlaceReportsMarkdown({ markdown }) {
  return (
    <Row>
      <Global styles={markDownStyles} />
      <div className="markdown-body">
        <Markdown>{markdown}</Markdown>
      </div>
    </Row>
  )
}
